import React, {useState, useEffect} from "react";
import TabPageHeader from "../../header/tabpageheader";
import GenericForm from "../../../../../dialog/genericform";
import {getFields} from "../../../../../dialog/formfields";
import PropTypes from "prop-types";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";
import MDBox from "../../../../../../components/MDBox";

const TransactionControlConfig = ({ selectedRowData }) => {
    const [initialData, setInitialData] = useState({});
    const [fields, setFields] = useState([]);
    const api = useConfigApi();
    const { transactionControlConfigFields } = getFields();

    const fetchTransactionControlConfig = async () => {
        try {
            const response = await api.get(Endpoints.transactionControl.getByControlSlNo(selectedRowData.slNo));
            const data = response?.data?.data || {};
            Object.keys(data).forEach(key => {
                if (data[key] === null || data[key] === undefined) {
                    data[key] = "";
                }
                // console.log("key", key, "value", data[key]);
                const val = String(data[key]).toLowerCase();
                if (val === "true") {
                data[key] = true;
                } else if (val === "false") {
                data[key] = false;
                }

            });
            setInitialData(data);
            let updatedFields = [...transactionControlConfigFields];
            if (data.slNo) {
                updatedFields = [
                    {
                        name: "slNo",
                        label: "SL No",
                        readonly: true,
                        value: data.slNo,
                        hidden: true
                    },
                    ...updatedFields,
                ];
            }
            setFields(updatedFields);
        } catch (error) {
            console.error("Failed to fetch transaction control config:", error);
            setFields(transactionControlConfigFields);
        }
    };

    useEffect(() => {
        fetchTransactionControlConfig().catch(console.error);
    }, [selectedRowData]);

    const handleRevertAll = () => { /* ... */ };
    const handleValidate = (formData) => {
        delete formData.controlId;
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        console.log("form data", formData);
        if(formData.slNo) {
            api.put(Endpoints.transactionControl.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Transaction Control config successfully created.");
                    console.log(response);
                    fetchTransactionControlConfig().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        } else {
            api.post(Endpoints.transactionControl.createOrUpdate, formData)
                .then((response) => {
                    toast.success("Transaction Control successfully updated.");
                    console.log(response);
                    fetchTransactionControlConfig().catch(console.error);
                })
                .catch((error) => {
                    toast.error("Internal error occurred while creating.");
                });
        }

    };

    return (
        <>
            <MDBox
                sx={{
                    px: 3,
                    py: 2,
                    bgcolor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <TabPageHeader
                    title="Transaction Control Config"
                    showButton={false}
                />
            </MDBox>
            <MDBox sx={{
                px: 3,
                py: 2,
                bgcolor: "#fff",
                borderBottom: "1px solid #d3e3fd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
            }}>
                {fields.length > 0 && (
                    <GenericForm
                    title="Transaction Control Form"
                    fields={fields}
                    initialData={initialData}
                    useDialog={false}
                    mode="edit"
                    onValidate={handleValidate}
                    onRevertAll={handleRevertAll}
                    />
                )}

            </MDBox>


        </>

    );
};

TransactionControlConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};

export default TransactionControlConfig;
